interface NavbarTogglerProps {
  expanded: boolean;
  onToggle: () => void;
}

const NavbarToggler = ({ onToggle, expanded }: NavbarTogglerProps) => {
  const active = expanded ? 'is-active' : '';

  return (
    <button
      className={`navbar-toggler hamburger hamburger--spin ${active}`}
      onClick={onToggle}
      type="button"
      aria-label="Toggle navigation"
      aria-controls="navigation"
      aria-expanded={expanded}
    >
      <span className="hamburger-box">
        <span className="hamburger-inner" />
      </span>
    </button>
  );
};

export default NavbarToggler;
